import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { IdentityPage } from "@/features/onboarding/pages/identity-page";

export const Route = createFileRoute("/onboarding/_guarded/identity")({
	head: () => pageTitle("Your identity information"),
	component: IdentityPage,
});
